const locale = {
  LOADER_TEXT: 'Cargando, por favor espere...',
};

export default locale;
